import type { LocalNote } from './db'

let prefetched: LocalNote | null = null

export function setPrefetchedNote(note: LocalNote): void {
  prefetched = note
}

export function consumePrefetchedNote(id: string): LocalNote | null {
  if (prefetched?.id === id) {
    const note = prefetched
    prefetched = null
    return note
  }
  prefetched = null
  return null
}
